import React, { useState } from 'react';
import { Row, Col, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
// External libraries
import moment from 'moment';
// utils
import formatMoney from 'utils/formatMoney';
import { handleCatchError, handleAPIError } from 'utils/handleErrors';
// components
import ButtonRequest from '../../../../components/buttons/ButtonRequest';
import { ToastSuccess } from '../../../../components/alerts/toast';
// api
import { addOverweight } from '../../../api/Api-admin';

const ChargesCard = ({ data }) => {
  const [isAddChargerLoader, setIsAddChargerLoader] = useState(false);
  // console.log('additional charges data:', data);
  const splitAuthor = (string) => {
    const index = string.indexOf('-'); // Encuentra el índice del primer guion
    if (index === -1) {
      return string; // Si no hay guion, retorna una string vacío
    }
    return string.substring(index + 1).toUpperCase(); // Retorna la parte de la cadena desde el guion hasta el final
  };
  const handlerAddOverweight = async () => {
    try {
      // console.log(`agregar sobrpesos de ${data.real_kg} kg, en la guai numeror: ${data?.shipping_id}`);
      setIsAddChargerLoader(true);
      const response = await addOverweight(data?.shipping_id, '', data.real_kg);
      // console.log('add overweight res:', response);
      if (response.overweight_charge !== undefined) {
        ToastSuccess('Sobrepeso cobrado correctamente ⭐');
      } else if (response.error) {
        handleAPIError(response);
      }
    } catch (error) {
      handleCatchError(error);
      // console.log('error catch');
    } finally {
      setIsAddChargerLoader(false); // disable loader in the button
    }
  };
  return (
    <Card className="mb-2 px-0">
      <Row className="g-0 h-100 sh-xl-9 position-relative">
        <Col className="py-4 py-xl-0 ps-4 pe-4 ps-sm-5 h-100 card bg-light" style={{ boxShadow: '0 4px 6px rgba(var(--separator-rgb), 0.5)' }}>
          <Row className="g-0 h-100 align-content-center">
            <Col xs="12" xl="2" className="mb-2 order-1 order-sm-3 order-xl-2 d-flex flex-column justify-content-center ">
              <div className="text-muted text-small mb-1 d-xl-none">ID Usuario </div>
              <OverlayTrigger delay={{ show: 800, hide: 0 }} placement="top" overlay={<Tooltip id="tooltip-top">Ver detalle de usuario</Tooltip>}>
                <NavLink className="anchor-effect-primary" to={`/users-all/detail/${data?.crm_user}`}>
                  <div className="text-truncate">{data?.crm_user}</div>
                </NavLink>
              </OverlayTrigger>
            </Col>
            <Col xs="12" sm="9" xl="3" className="mb-xl-0 mb-2 pe-3 h-xl-100 order-2 d-flex flex-column justify-content-center bg-infox">
              <div className="text-muted text-small d-xl-none mb-1">Concepto / ID Envío </div>
              <div className="text-alternate">{data?.statement_text}</div>
              <OverlayTrigger delay={{ show: 800, hide: 0 }} placement="top" overlay={<Tooltip id="tooltip-top">Ver detalle de envío</Tooltip>}>
                <NavLink className="anchor-effect-primary" to={`/shipping-all/detail/${data?.shipping_id}/${data?.legal_name}/${data?.crm_user}`}>
                  <div>{data?.shipping_id}</div>
                </NavLink>
              </OverlayTrigger>
            </Col>

            <Col
              xs="12"
              sm="3"
              xl="2"
              className="pe-1 mb-4 mb-xl-0 order-3 order-sm-2 order-xl-3 d-flex flex-column justify-content-center align-items-sm-end align-items-xl-center"
            >
              <div className="text-muted text-small d-xl-none">{data?.status === 'Completed' ? 'Fecha cargo' : 'Fecha intento'}</div>
              <div className="lh-1 text-alternate">{`${moment(data?.creation_date).format('DD-MM-YYYY')}`}</div>
              <div className="lh-1 text-muted mt-0 mt-xl-1 ms-1 ms-xl-0">{data?.creation_date.slice(11, 19)}</div>
            </Col>
            <Col xs="4" sm="4" xl="2" className="pe-1 mb-2 mb-xl-0 order-5 d-flex flex-column justify-content-center align-items-end">
              <div className="text-muted text-small d-xl-none">Referencia</div>
              <div className="lh-1 text-muted">{data?.reference_trace}</div>
            </Col>
            {/* 5 kg reales */}
            <Col xs="4" sm="4" xl="1" className="pe-1 mb-2 mb-xl-0 order-5 d-flex flex-column justify-content-center align-items-end">
              <div className="text-muted text-small d-xl-none">Cargo</div>
              <span className={`lh-1 text-alternative ${data?.refunded ? 'text-success' : 'text-primary'}`}>
                <span className="text-small text-muted">$</span>
                {formatMoney(data?.charge)}
              </span>
              <div className={`lh-1 text-small mt-1 text-success ${data?.refunded ? 'd-block' : 'd-none'}`}>Reembolsado</div>
            </Col>

            {/* 7. autor o btn cobrar */}
            <Col xs="12" sm="12" xl="2" className="order-last mb-2 mt-2 d-flex flex-column justify-content-center align-items-end bg-infox">
              <div className=" text-muted text-small mb-1 d-xl-none">Autor</div>

              {data?.author ? (
                <div className="text-medium text-alternate">{splitAuthor(data?.author)}</div>
              ) : (
                <ButtonRequest
                  color="outline-primary"
                  title="Cobrar"
                  titleLoading="Cobrar"
                  handlerFn={handlerAddOverweight}
                  isButtonDisabled={isAddChargerLoader}
                  isLoading={isAddChargerLoader}
                />
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default ChargesCard;
